import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from '../pages/HomePage';
import TermsCondition from '../pages/TermsAndConditions';
import Privacy from '../pages/PrivacyPolicy';
import CancellationPolicy from "../pages/CancellationPolicy";
import Support from "../pages/Support";
import BecomePartner from "../pages/BecomePartner";
import PostYourLegalIssue from "../pages/PostYourLegalIssue";
import ConsultationCall from "../pages/ConsultationCall";
import ChatWithLawyers from "../pages/ChatWithLawyers";
import AboutLegalCompany from "../pages/AboutLegalCompany";
import HireALawyer from "../pages/HireALawyer";
import ForCorporate from "../pages/ForCorporate";
import ForUsers from "../pages/ForUsers";
import ForLawFirms from "../pages/ForLawFirms";
import ForLawyers from "../pages/ForLawyers";
import BusinessPortal from "../pages/BusinessPortal";
import HireMultipleLawyers from "../pages/HireMultipleLawyers";
import LawFirm from "../pages/LawFirm";
import Corporate from "../pages/Corporate";
import BusinessAndCorporateLaw from "../pages/BusinessAndCorporateLaw";
import LegalConsultation from "../pages/LegalConsultation";
import Services from "../pages/Services";
import Blog from "../pages/Blog";
import ContractServices from "../pages/ContractServices";
import PropertyAndRealEstateLaw from "../pages/PropertyAndRealEstateLaw";
import FamilyAndPersonalMatters from "../pages/FamilyAndPersonalMatters";
import ImmigrationAndVisaLaw from "../pages/ImmigrationAndVisaLaw";
import DisputeResolution from "../pages/DisputeResolution";
import IntellectualProperty from "../pages/IntellectualProperty";
import StartupAndBusinessSetup from "../pages/StartupAndBusinessSetup";
import LawyerRegistration from "../pages/LawyerRegistration";
import ThankYou from "../pages/ThankYou";
import { LawyerGuestRoute, LawyerPrivateRoute, LawyerIndexRedirect } from "../components/lawyer/LawyerRoutes";
import LawyerLayout from "../components/lawyer/LawyerLayout";
import LawyerLogin from "../pages/lawyer/LawyerLogin";
import LawyerVerifyOtp from "../pages/lawyer/LawyerVerifyOtp";
import LawyerSignup from "../pages/lawyer/LawyerSignup";
import LawyerDashboard from "../pages/lawyer/LawyerDashboard";
import LawyerCallHistory from "../pages/lawyer/LawyerCallHistory";
import LawyerChats from "../pages/lawyer/LawyerChats";
import LawyerSettings from "../pages/lawyer/LawyerSettings";
import LawyerProfile from "../pages/lawyer/LawyerProfile";
import LawyerRequests from "../pages/lawyer/LawyerRequests";
import LawyerQuestionAnswer from "../pages/lawyer/LawyerQuestionAnswer";
import LawyerClients from "../pages/lawyer/LawyerClients";
import LawyerServiceChat from "../pages/lawyer/LawyerServiceChat";
import LawyerPayout from "../pages/lawyer/LawyerPayout";
import LawyerEarnings from "../pages/lawyer/LawyerEarnings";
import LawyerCallPricing from "../pages/lawyer/LawyerCallPricing";
import LawyerNotifications from "../pages/lawyer/LawyerNotifications";
import LawyerBusinessServices from "../pages/lawyer/LawyerBusinessServices";
import LawyerEditProfile from "../pages/lawyer/LawyerEditProfile";
import LawyerContact from "../pages/lawyer/LawyerContact";
import LawyerGetApp from "../pages/lawyer/LawyerGetApp";
import { UserGuestRoute, UserPrivateRoute, UserIndexRedirect } from "../components/user/UserRoutes";
import UserLayout from "../components/user/UserLayout";
import UserLogin from "../pages/user/UserLogin";
import UserSignup from "../pages/user/UserSignup";
import UserVerifyOtp from "../pages/user/UserVerifyOtp";
import UserDashboard from "../pages/user/UserDashboard";
import UserLawyers from "../pages/user/UserLawyers";
import UserProfile from "../pages/user/UserProfile";
import UserEditProfile from "../pages/user/UserEditProfile";
import UserLawyerDetails from "../pages/user/UserLawyerDetails";
import UserVideoCall from "../pages/user/UserVideoCall";
import UserCallHistory from "../pages/user/UserCallHistory";
import UserChats from "../pages/user/UserChats";
import UserRequests from "../pages/user/UserRequests";
import UserQuestionDetails from "../pages/user/UserQuestionDetails";
import UserAskQuestion from "../pages/user/UserAskQuestion";
import UserNotifications from "../pages/user/UserNotifications";
import UserMyLawyers from "../pages/user/UserMyLawyers";
import AppDownloadBanner from "../components/AppDownloadBanner";

const AppRouter = () => {
    const basePath = process.env.REACT_APP_BASE_PATH;

    return (
      <Router basename={basePath}>
        <AppDownloadBanner />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/terms" element={<TermsCondition />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/support" element={<Support />} />
          <Route path="/become-a-partner" element={<BecomePartner />} />
          <Route path="/cancellation-policy" element={<CancellationPolicy />} />
          <Route path="/post-your-legal-issue" element={<PostYourLegalIssue />} />
          <Route path="/consultation-call" element={<ConsultationCall />} />
          <Route path="/chat-with-lawyers" element={<ChatWithLawyers />} />
          <Route path="/about-legal-company" element={<AboutLegalCompany />} />
          <Route path="/hire-a-lawyer" element={<HireALawyer />} />
          <Route path="/for-corporate" element={<ForCorporate />} />
          <Route path="/for-users" element={<ForUsers />} />
          <Route path="/for-law-firms" element={<ForLawFirms />} />
          <Route path="/for-lawyers" element={<ForLawyers />} />
          <Route path="/business-portal" element={<BusinessPortal />} />
          <Route path="/hire-multiple-lawyers" element={<HireMultipleLawyers />} />
          <Route path="/law-firm" element={<LawFirm />} />
          <Route path="/corporate" element={<Corporate />} />
          <Route path="/business-corporate-law" element={<BusinessAndCorporateLaw />} />
          <Route path="/legal-consultation" element={<LegalConsultation />} />
          <Route path="/contract-services" element={<ContractServices />} />
          <Route path="/property-real-estate-law" element={<PropertyAndRealEstateLaw />} />
          <Route path="/family-personal-matters" element={<FamilyAndPersonalMatters />} />
          <Route path="/immigration-visa-law" element={<ImmigrationAndVisaLaw />} />
          <Route path="/dispute-resolution" element={<DisputeResolution />} />
          <Route path="/intellectual-property" element={<IntellectualProperty />} />
          <Route path="/startup-business-setup" element={<StartupAndBusinessSetup />} />
          <Route path="/services" element={<Services />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/lawyer-registration" element={<LawyerRegistration />} />
          <Route path="/thank-you" element={<ThankYou />} />

          {/* Lawyer portal */}
          <Route path="/lawyer" element={<LawyerIndexRedirect />} />
          <Route element={<LawyerGuestRoute />}>
            <Route path="/lawyer/login" element={<LawyerLogin />} />
            <Route path="/lawyer/verify-otp" element={<LawyerVerifyOtp />} />
            <Route path="/lawyer/signup" element={<LawyerSignup />} />
          </Route>
          <Route element={<LawyerPrivateRoute />}>
            <Route element={<LawyerLayout />}>
              <Route path="/lawyer/dashboard" element={<LawyerDashboard />} />
              <Route path="/lawyer/call-history" element={<LawyerCallHistory />} />
              <Route path="/lawyer/chat" element={<LawyerChats />} />
              <Route path="/lawyer/chat/:chatId" element={<LawyerChats />} />
              <Route path="/lawyer/settings" element={<LawyerSettings />} />
              <Route path="/lawyer/profile" element={<LawyerProfile />} />
              <Route path="/lawyer/profile/edit" element={<LawyerEditProfile />} />
              <Route path="/lawyer/business-services" element={<LawyerBusinessServices />} />
              <Route path="/lawyer/payout-method" element={<LawyerPayout />} />
              <Route path="/lawyer/get-app" element={<LawyerGetApp />} />
              <Route path="/lawyer/call-pricing" element={<LawyerCallPricing />} />
              <Route path="/lawyer/notifications" element={<LawyerNotifications />} />
              <Route path="/lawyer/contact" element={<LawyerContact />} />
              <Route path="/lawyer/earnings" element={<LawyerEarnings />} />
              <Route path="/lawyer/requests" element={<LawyerRequests />} />
              <Route path="/lawyer/requests/questions/:questionId" element={<LawyerQuestionAnswer />} />
              <Route path="/lawyer/clients" element={<LawyerClients />} />
              <Route path="/lawyer/clients/:chatId" element={<LawyerServiceChat />} />
            </Route>
          </Route>
          <Route path="/lawyer/*" element={<Navigate to="/lawyer" replace />} />

          {/* User (client) portal */}
          <Route path="/user" element={<UserIndexRedirect />} />
          <Route element={<UserGuestRoute />}>
            <Route path="/user/login" element={<UserLogin />} />
            <Route path="/user/signup" element={<UserSignup />} />
            <Route path="/user/verify-otp" element={<UserVerifyOtp />} />
          </Route>
          <Route element={<UserPrivateRoute />}>
            <Route element={<UserLayout />}>
              <Route path="/user/dashboard" element={<UserDashboard />} />
              <Route path="/user/lawyers" element={<UserLawyers />} />
              <Route path="/user/lawyers/:lawyerId" element={<UserLawyerDetails />} />
              <Route path="/user/video-call" element={<UserVideoCall />} />
              <Route path="/user/my-lawyers" element={<UserMyLawyers />} />
              <Route path="/user/call-history" element={<UserCallHistory />} />
              <Route path="/user/chat" element={<UserChats />} />
              <Route path="/user/chat/:chatId" element={<UserChats />} />
              <Route path="/user/requests" element={<UserRequests />} />
              <Route path="/user/requests/new" element={<UserAskQuestion />} />
              <Route path="/user/requests/:questionId" element={<UserQuestionDetails />} />
              <Route path="/user/notifications" element={<UserNotifications />} />
              <Route path="/user/profile" element={<UserProfile />} />
              <Route path="/user/profile/edit" element={<UserEditProfile />} />
            </Route>
          </Route>
          <Route path="/user/*" element={<Navigate to="/user" replace />} />
        </Routes>
      </Router>
    );
};

export default AppRouter;
